import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";

const CreativeHubIcon = {
  name: 'CreativeHubIcon',
  props: {
    size: {
      type: String,
      default: '24',
      validator: function (s) {
        return !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x';
      }
    }
  },
  functional: true,
  render: function (h, ctx) {
    var size = ctx.props.size.slice(-1) === 'x' 
      ? ctx.props.size.slice(0, ctx.props.size.length - 1) + 'em'
      : parseInt(ctx.props.size) + 'px';
    var attrs = ctx.data.attrs || {};
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    ctx.data.attrs = attrs;
    
    return h("svg", _mergeJSXProps([{
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "25",
        viewBox: "0 0 24 25",
        fill: "none",
        "stroke-width": "0px"
      },
      "class": "feather feather-creative-hub"
    }, ctx.data]), [
      h("g", {
        attrs: {
          opacity: "0.7"
        }
      }, [
        h("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M12 4C7.30544 4 3.5 7.80544 3.5 12.5C3.5 17.1946 7.30544 21 12 21C16.6937 21 20.5 17.1945 20.5 12.5C20.5 7.80549 16.6937 4 12 4ZM2 12.5C2 6.97701 6.47701 2.5 12 2.5C17.522 2.5 22 6.97696 22 12.5C22 18.023 17.522 22.5 12 22.5C6.47701 22.5 2 18.023 2 12.5Z",
            fill: "currentColor"
          }
        }),
        h("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M9.66394 8.26855L16.3203 12.4953L9.66394 16.7221V8.26855ZM11.1639 10.9979V13.9927L13.5221 12.4953L11.1639 10.9979Z",
            fill: "currentColor"
          }
        })
      ])
    ]);
  }
};

export default CreativeHubIcon; 